// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
h2 {
  margin-top: 3%;
}

.mat-mdc-row:nth-child(even) {
  background-color: #e3e3e3;
}

.mat-mdc-row:nth-child(odd) {
  background-color: white;
}

.no-border {
  border: none;
}

.search-input-container {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 5%;
  flex-grow: 2;
}
.search-input-container input {
  flex: 0 0 50%;
  font-size: 14px;
  height: 38px;
}
.search-input-container .search-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0066b2 0% 0% no-repeat padding-box;
  width: 5%;
  height: 38px;
  color: white;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
}
.search-input-container .search-btn:hover {
  background-color: #0b2d71;
}

.progress-bar-container {
  min-height: 3px;
  margin: 1% 2%;
}
.progress-bar-container .searching-progress-bar {
  height: 5px;
}

.link-preview {
  color: #0066b2;
  cursor: pointer;
}

.name-col {
  max-width: 70%;
}

.preview-col {
  max-width: 10%;
}

.navigation-buttons {
  margin: 25px 0;
  display: flex;
  flex-direction: row;
  gap: 3%;
  justify-content: flex-end;
}
.navigation-buttons button {
  margin: 10px 15px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
